import { marked } from 'marked';
import DOMPurify from 'isomorphic-dompurify';
import { serverUrl } from '../data/dataApi';

export const validateEmail = (email, setEmailError) => {
    if (!email) {
        setEmailError("Please enter your email address.");
    } else if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(email)) {
        setEmailError("The email address you entered is not valid. Please try again.");
    } else {
        return "success";
    }
};

export const validatePassword = (password, setPasswordError) => {
    if(!password) {
        setPasswordError("Please enter your password.");
    } else {
        return "success";
    }
};

export const roles = {
    admin: "Administrator",
    viewer: "Viewer",
};

export const formatDate = (timestamp) => {
    const date = new Date(new Date(timestamp).getTime() - (new Date().getTimezoneOffset() * 60000));
    const offsetDate = date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

    return offsetDate;
};

export const isValidUrl = (string) => {
    try {
        new URL(string);
        return true;
    } catch (err) {
        return false;
    }
};

export const sanitizeSearchResult = (message) => message ? message.replace(/<\/?[^>]+(>|$)/g, '') : "";

export const additionalSourceDocuments = {
    "ALD_Materials.pdf": [{ title: "ALD Materials", url: "https://technical.gelest.com/brochures/ald-materials/ald-materials/" }],
    "Acetylenic_and_Alkynyl_Silanes.pdf": [{ title: "Acetylenic and Alkynyl Silanes", url: "https://technical.gelest.com/brochures/acetylenic-and-alkynyl-silanes/acetylenic-and-alkynyl-silanes/" }],
    "alkylsilicates-1.pdf": [{ title: "Alkylsilicates for Cross-Coupling", url: "https://technical.gelest.com/brochures/alkylsilicates-for-cross-coupling/alkylsilicates-for-cross-coupling/" }],
    "BIOSAFE.pdf": [{ title: "BIOSAFE®", url: "https://technical.gelest.com/brochures/biosafe/biosafe/" }],
    "Borazine_The_Simple_Solution_for_Boron_Nitride.pdf": [{ title: "Borazine: The Simple Solution for Boron Nitride", url: "https://technical.gelest.com/brochures/borazine-the-simple-solution-for-boron-nitride/borazine-the-simple-solution-for-boron-nitride/" }],
    "Bulk_Metal-Organics_and_Silanes.pdf": [{ title: "Bulk Metal-Organics and Silanes: Pharmaceutical & Organic Synthesis", url: "https://technical.gelest.com/brochures/bulk-metal-organics-and-silanes-pharmaceutical-organic-synthesis/bulk-metal-organics-and-silanes-pharmaceutical-organic-synthesis/" }],
    "CVD_Materials-Co_Zr_Ru_Hf_Ta.pdf": [{ title: "CVD Materials (Co, Zr, Ru, Hf, Ta)", url: "https://technical.gelest.com/brochures/cvd-materials-co-zr-ru-hf-ta/cvd-materials/" }],
    "Hybrid_Fluids_for_Personal_Care.pdf": [{ title: "Cosmetic Fluids", url: "https://technical.gelest.com/brochures/cosmetic-fluids/hybrid-fluids-for-personal-care/" }],
    "Tailoring_Surfaces_for_Cosmetic_Innovation.pdf": [{ title: "Cosmetic Pigments", url: "https://technical.gelest.com/brochures/cosmetic-pigments/tailoring-surfaces-for-cosmetic-innovation/" }],
    "Formulary_for_Personal_Care_and_Color_Cosmetics.pdf": [{ title: "Formulary: Personal Care and Color Cosmetics", url: "https://technical.gelest.com/brochures/formulary-personal-care-and-color-cosmetics/formulary-personal-care-and-color-cosmetics/" }],
    "Functional-Silane-Blends-SIVATE-compressed.pdf": [{ title: "Functional Silane Blends: SIVATE", url: "https://technical.gelest.com/brochures/functional-silane-blends-sivate/functional-silane-blends-sivate/" }],
    "High_Elongation_Silicones.pdf": [{ title: "High Elongation Silicones", url: "https://technical.gelest.com/brochures/high-elongation-silicones-exsil/high-elongation-silicones-exsil/" }],
    "Hydrophobicity-Hydrophilicity_and_Silane_Surface_Modification.pdf": [{ title: "Hydrophobicity, Hydrophilicity, and Silane Surface Modification", url: "https://technical.gelest.com/brochures/hydrophobicity-hydrophilicity-and-silane-surface-modification/hydrophobicity-hydrophilicity-and-silane-surface-modification/" }],
    "Industrial_Silanes.pdf": [{ title: "Industrial Silanes for Adhesives, Sealants, Coatings, and Composites", url: "https://technical.gelest.com/brochures/industrial-silanes-for-adhesives-sealants-coatings-and-composites/industrial-silanes/" }],
    "Methyl_Silanes.pdf": [{ title: "Methyl Silanes", url: "https://technical.gelest.com/brochures/methyl-silanes/methyl-silanes/" }],
    "Silicone_Materials_for_Microfluidics.pdf": [{ title: "Microfluidics", url: "https://technical.gelest.com/brochures/microfluidics/microfluidics/" }],
    "Micro-Particle_Surface_Modification.pdf": [{ title: "Microparticle Surface Modification", url: "https://technical.gelest.com/brochures/microparticle-surface-modification/microparticle-surface-modification/" }],
    "IncluSiGel-305-WEB-v1.0.pdf": [{ title: "Multifunctional Polymer Mixtures", url: "https://technical.gelest.com/brochures/multifunctional-polymer-mixtures/multifunctional-polymer-mixtures/" }],
    "Optical-Materials-combined.pdf": [{ title: "Optical Materials", url: "https://technical.gelest.com/brochures/optical-materials/optical-materials/" }],
    "Organosilicon_Metal-Organic_Renewable_Energy.pdf": [{ title: "Organosilicon & Metal-Organic Materials for Renewable Energy", url: "https://technical.gelest.com/brochures/organosilicon-and-metal-organic-materials-for-renewable-energy/organosilicon-and-metal-organic-materials-for-renewable-energy/" }],
    "Organosilicon_Metal-Organic_Microelectronics.pdf": [{ title: "Organosilicon & Metal-Organic Precursors for Microelectronics & Optoelectronics", url: "https://technical.gelest.com/brochures/organosilicon-metal-organic-precursors-for-microelectronics-optoelectronics/organosilicon-metal-organic-precursors-for-microelectronics-optoelectronics/" }],
    "gelest-performance-products.pdf": [{ title: "Performance (Pre-formulated) Products", url: "https://technical.gelest.com/brochures/performance-pre-formulated-products/performance-products/" }],
    "Preserving-and-Cleansing-Technology.pdf": [{ title: "Preserving and Cleansing Technology", url: "https://technical.gelest.com/brochures/preserving-and-cleansing-technology/preserving-and-cleansing-technology/" }],
    "Reactive-Polyethers.pdf": [{ title: "Reactive Polyethers", url: "https://technical.gelest.com/brochures/reactive-polyethers/what-are-heterobifunctional-pegylation-reagents/" }],
    "Reactive_SIlicones.pdf": [{ title: "Reactive Silicones", url: "https://technical.gelest.com/brochures/reactive-silicones/reactive-silicones/" }],
    "Silane_Coupling_Agents.pdf": [{ title: "Silane Coupling Agents", url: "https://technical.gelest.com/brochures/silane-coupling-agent/silane-coupling-agents/" }],
    "Silanes_and_Silicones_for_Epoxy_Resins.pdf": [{ title: "Silanes and Silicones for Epoxy Resins", url: "https://technical.gelest.com/brochures/silanes-and-silicones-for-epoxy-resins/silanes-and-silicones-for-epoxy-resins-introduction/" }],
    "Silicon_Nitride.pdf": [{ title: "Silicon Nitride Precursors", url: "https://technical.gelest.com/brochures/silicon-nitride-precursors/4911-2/" }],
    "Silicon-Based_Blocking_Agents.pdf": [{ title: "Silicon-Based Blocking Agents", url: "https://technical.gelest.com/brochures/silicon-based-blocking-agents/silicon-based-blocking-agents-2/" }],
    "Silicon-Based_Cross-Coupling_Reagents-1.pdf": [{ title: "Silicon-Based Cross-Coupling Agents", url: "https://technical.gelest.com/brochures/silicon-based-cross-coupling-reagents/silicon-based-cross-coupling-agents/" }],
    "Silicon-Based_Reducing_Agents.pdf": [{ title: "Silicon-Based Reducing Agents", url: "https://technical.gelest.com/brochures/silicon-based-reducing-agents/silicon-based-reducing-agents/" }],
    "Inert_Silicones.pdf": [{ title: "Silicone Fluids: Stable, Inert Media", url: "https://technical.gelest.com/brochures/silicone-fluids/silicone-fluids-stable-inert-media/" }],
    "Specialty_Olefins.pdf": [{ title: "Specialty Olefins", url: "https://technical.gelest.com/brochures/specialty-olefins/specialty-olefins/" }],
    "Enabling_Synthetic_Organic_Transformations.pdf": [{ title: "Synthetic Reagents: Organosilicon-Based & Metal-Organics", url: "https://technical.gelest.com/brochures/synthetic-reagents-organosilion-based-metal-organic/enabling-synthetic-organictransformations/" }],
    "Thermally-conductive-silicones.pdf": [{ title: "Thermally Conductive Silicones", url: "https://technical.gelest.com/brochures/thermally-conductive-silicones/thermally-conductive-silicones/" }],
};

export const handleRemoveFeedback = async (sessionInfo, id) => {
    const response = await fetch(`${serverUrl}/api/remove-feedback/${id}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            session_id: sessionInfo.id,
            ip: sessionInfo.userIp,
        }),
    });

    const data = await response.json();

    return data;
};

const noResultsSubstrings = [
    "sorry",
    "I don't"
];

export const checkInconclusiveResponse = (response) => typeof response === "string" ? noResultsSubstrings.some(substring => response.toLowerCase().includes(substring.toLowerCase())) : false;

export const unexpectedError =
    "An error occurred while fetching the data. Please try again.";

export const cleanMessage = (message) => {
    if (message) {
        const parts = message.split(/(<\/?[a-z][\s\S]*?>)/g);

        let insideHTML = false;

        // HTML is mixed with markdown. If HTML is encountered, leave it as is.
        const processedParts = parts.map(part => {
            if (/<\/?[a-z][\s\S]*>/i.test(part)) {
                insideHTML = /<[^\/][a-z][\s\S]*?>/i.test(part) ? true : insideHTML;
                insideHTML = /<\/[a-z][\s\S]*?>/i.test(part) ? false : insideHTML;

                return part;
            } else if (part.trim()) {
                if (insideHTML) {
                    return part;
                }
                return marked.parse(part.trim());
            }
            return '';
        });

        const renderedMessage = processedParts.join("");

        return DOMPurify.sanitize(renderedMessage, { ADD_ATTR: ['target'] });
    }

    return "";
};

export const initialFeedbackDetails = {
    userMessage: "",
    apiMessage: "",
    content: "",
    reason: [],
};

export const handleSendFeedback = async (allMessages, sessionInfo, rating, feedbackDetails, messageIndex, userEmail) => {
    const getRatingDetails = () => {
        let fetchBody = {
            ...feedbackDetails,
            rating,
            history: allMessages.messages,
            ip: sessionInfo.userIp,
            time: new Date(Date.now()).toISOString().replace('T', ' ').replace('Z', ''),
            message_id: allMessages[messageIndex].id,
            user_email: userEmail,
        };

        if (rating === "up" && allMessages[messageIndex].message) {
            fetchBody = {
                ...initialFeedbackDetails,
                rating,
                history: allMessages.messages,
                ip: sessionInfo.userIp,
                apiMessage: allMessages[messageIndex].message,
                userMessage: allMessages[messageIndex - 1].message,
                message_id: allMessages[messageIndex].id,
                time: new Date(Date.now()).toISOString().replace('T', ' ').replace('Z', ''),
                user_email: userEmail,
            };
        }

        return fetchBody;
    };

    const response = await fetch(`${serverUrl}/api/feedback`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ...getRatingDetails(),
            session_id: sessionInfo.id,
        }),
    });

    const data = await response.json();

    return data;
};

export const handleUpRating = async (e, messageIndex, messages, setMessages, sessionInfo, feedbackDetails, setChatError, userEmail) => {
    if (!messages[messageIndex].rating && messages[messageIndex].rating !== "down") {
        try {
            const data = await handleSendFeedback(messages, sessionInfo, "up", feedbackDetails, messageIndex, userEmail);

            if (data.error) {
                setChatError(unexpectedError);
            } else if (data.success) {
                const feedbackId = data.data.rows[0].id;

                setMessages(prevState => ([
                    ...prevState.map((message, index) => {
                        if (index === messageIndex) {
                            message.rating = "up";
                            message.ratingId = feedbackId;
                        }

                        return message;
                    }),
                ]));

                e.target.dataset.feedbackId = feedbackId;
            }
        } catch (error) {
            console.error(error)
            setChatError(unexpectedError);
        }
    } else if (e.target.dataset.feedbackId) {
        try {
            const data = await handleRemoveFeedback(sessionInfo, e.target.dataset.feedbackId);

            if (data.error) {
                setChatError(unexpectedError);
            } else if (data.success) {
                setMessages(prevState => ([
                    ...prevState.map((message, index) => {
                        if (index === messageIndex) {
                            message.rating = "";
                        }

                        return message;
                    }),
                ]));

                e.target.removeAttribute("data-feedback-id");
            }
        } catch (error) {
            console.error(error)
            setChatError(unexpectedError);
        }
    }
};

export const handleOpenFeedback = (messageKey, setMessageKey, setFeedbackDetails, setFeedbackOpen, messages) => {
    setFeedbackOpen(false);
    if (!messages[messageKey].rating) {
        setFeedbackDetails(prevState => ({ ...prevState, apiMessage: messages[messageKey].message, userMessage: messages[messageKey - 1].message }));
        setFeedbackOpen(true);
        setMessageKey(messageKey);
    }
};

export const feedbackReasons = [
    {
        id: "harmful-unsafe",
        title: "This is harmful/unsafe",
    },
    {
        id: "untrue",
        title: "This isn't true",
    },
    {
        id: "unhelpful",
        title: "This isn't helpful",
    },
];

export const forkPromptsMetadata = {
    document_retrieval: {
        message: "Hello, I'm the Gelest Document Retrieval Bot. Please describe the type of content you are looking for, and I'll search through Gelest's library of catalogs and publications to try to find some resources that may help your search.",
        inputPlaceholder: "Ask me about a Gelest document",
        suggestions: [
            "I need the SDS for 3-Aminopropyltriethoxysilane (SIA0610.0)",
            "I'm looking for technical information on silane coupling agents"
        ],
        viewingLabel: {
            name: "Document Retrieval Tool",
            message: "Ask the bot for help finding an answer in any Gelest Document"
        }
    },
    other: {
        message: "Hello, I'm the Gelest Navigator AI Assistant. Please describe the type of content you are looking for and I'll search through Gelest's library of catalogs and publications to try to find some resources that may help your search. Feel free to be vague or use specifics like Term, Product Code, CAS#, Chemical Name, Formula, etc.",
        name: "Gelest Navigator AI Assistant 2.0",
        inputPlaceholder: "Ask me a question",
        suggestions: [],
        viewingLabel: {
            name: "General Open Question Tool",
            message: "Ask the bot general questions about Gelest products, applications, support or whatever you need help with"
        }
    },
};

export const getBotMetadata = (forkPrompt, property) => forkPromptsMetadata[forkPrompt][property];

export const formatMessages = messages => {
    const formattedMessages = [];

    for (let i = 0; i < messages.length; i++) {
        const message = messages[i];
        const formattedUserMessage = {
            type: "userMessage",
            message: message.user_message,
        };

        const formatteApiMessage = {
            id: message.id,
            type: "apiMessage",
            message: message.api_response,
            rating: message.rating,
            ratingId: message.feedback_id,
            products: message.products || undefined,
        };

        formattedMessages.push(formattedUserMessage);
        formattedMessages.push(formatteApiMessage);
    }

    return formattedMessages;
};

export const forkPrompts = {
    document_retrieval: "Document Retrieval",
    other: "General Open Questions",
};

export const botTypes = {
    document_retrieval: "Document Retrieval",
    other: "General Open Questions",
    navigator: "Navigator",
    chatbot: "Chatbot",
    product_search: "Product Search",
};